@if (!isUsingPwa()) {
    <button (click)="togglePwaGuide()" id="pwa-guide-toggle-button" class="open-button" aria-haspopup="dialog" aria-controls="installModal" mat-button>
        <span> Sådan installerer du Supportsystemet </span>
    </button>
}

@if (showModal()) {
    <div class="overlay" (click)="closePwaGuide()"></div>
    <div
        class="guide-modal"
        role="dialog"
        [class.slide-down]="isClosing"
        aria-modal="true"
        aria-labelledby="modalTitle"
        id="installModal"
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="true"
    >
        <div class="modal-content">
            <button mat-icon-button class="close-dialog" id="pwa-guide-close-button" aria-label="Luk installationsvejledning" (click)="closePwaGuide()" type="button">
                <mat-icon class="material-symbols-outlined" aria-hidden="true">close</mat-icon>
            </button>

            <h2 class="h3" id="modal-title">Installer Supportsystemet på din enhed</h2>

            <nav aria-label="Platform faner">
                <ul class="guide-modal__tabs" id="pwa-guide-tab-list" role="tablist">
                    <li>
                        <button role="tab" [attr.aria-selected]="selectedTab() === 'windows'" [class.active]="selectedTab() === 'windows'" (click)="setTab('windows')">
                            Windows
                        </button>
                    </li>
                    <li>
                        <button role="tab" [attr.aria-selected]="selectedTab() === 'mac'" [class.active]="selectedTab() === 'mac'" (click)="setTab('mac')">Mac</button>
                    </li>
                    <li>
                        <button role="tab" [attr.aria-selected]="selectedTab() === 'ios'" [class.active]="selectedTab() === 'ios'" (click)="setTab('ios')">iOS</button>
                    </li>
                    <li>
                        <button role="tab" [attr.aria-selected]="selectedTab() === 'android'" [class.active]="selectedTab() === 'android'" (click)="setTab('android')">
                            Android
                        </button>
                    </li>
                </ul>
            </nav>

            <section id="pwa-guide-tab-panel" class="guide-modal__tab-content">
                @switch (selectedTab()) {
                    @case ("windows") {
                        <div role="tabpanel">
                            <h3 class="guide-modal__tabs-header">Windows (Edge eller Chrome)</h3>
                            <ol>
                                <li>Åbn Supportsystemet i Edge eller Chrome.</li>
                                <li>
                                    Klik på menuen
                                    <mat-icon class="material-symbols-outlined text-icon" aria-hidden="true">more_vert</mat-icon>
                                    i øverste højre hjørne.
                                </li>
                                <li>Vælg <strong>Apps > Installer Supportsystem</strong> eller <strong> Cast, gem og del > Installer Supportsystem</strong>.</li>
                                <li>Bekræft installationen.</li>
                            </ol>
                        </div>
                    }
                    @case ("mac") {
                        <div role="tabpanel">
                            <h3 class="guide-modal__tabs-header">Mac (Safari)</h3>
                            <ol>
                                <li>Åbn Supportsystemet i Safari.</li>
                                <li>Klik på <strong>Arkiv &gt; Føj til Dock…</strong> i topmenuen.</li>
                                <li>Følg vejledningen for at føje appen til Dock.</li>
                            </ol>
                        </div>
                    }
                    @case ("ios") {
                        <div role="tabpanel">
                            <h3 class="guide-modal__tabs-header">iOS (Safari)</h3>
                            <ol>
                                <li>Åbn Supportsystemet i Safari.</li>
                                <li>
                                    Tryk på
                                    <img src="/assets/images/ios-share.svg" aria-label="Del ikon" style="height: 1.5rem; vertical-align: middle" />
                                    <strong>Del-ikonet</strong> nederst.
                                </li>
                                <li>Vælg <strong>Føj til hjemmeskærm</strong>.</li>
                                <li>Tryk <strong>Tilføj</strong> i øverste højre hjørne.</li>
                            </ol>
                        </div>
                    }
                    @case ("android") {
                        <div role="tabpanel">
                            <h3 class="guide-modal__tabs-header">Android (Chrome)</h3>
                            <ol>
                                <li>Åbn Supportsystemet i Chrome.</li>
                                <li>Hvis du kan se en <strong>Installer app</strong>-prompt — tryk på den.</li>
                                <li>
                                    Hvis ikke, tryk på
                                    <mat-icon class="material-symbols-outlined text-icon" aria-hidden="true">more_vert</mat-icon>
                                    <strong>menuen</strong>.
                                </li>
                                <li>Vælg <strong>Installer app</strong> og bekræft.</li>
                            </ol>
                        </div>
                    }
                }
            </section>
        </div>
    </div>
}
